import React, { Component } from 'react'
import { NavLink, Link, withRouter } from 'react-router-dom'
import { MdMenu } from 'react-icons/md'
import { connect } from 'react-redux'
import * as actions from './actions'
import * as routes from './routes'
import ReactGA from 'react-ga'
import SignOutLink from './SignOut'
import Icon from 'react-icons-kit'
import axios from 'axios'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'
import {encode, decode} from './Store'
import SignIn from './SignIn'


import './Navigation.css'


ReactGA.initialize('UA-84358701-1')


class UserMenu extends Component {
  state = {
    open: false
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    let { open } = this.state
    let { username, premium } = this.props
    return <>
        <a className={open ? 'active' : ''} onClick={this.toggleOpen}>{premium && <Icon size={15} icon={ic_check_circle} />}{username}</a>
        { open && 
          <div>
            <div className='usermenu'>
              <NavLink to={`/u/${username}/`} onClick={this.toggleOpen}>View Profile</NavLink>
              <NavLink to={`/likes/`} onClick={this.toggleOpen}>My Likes</NavLink>
              <SignOutLink onClick={this.toggleOpen} />
            </div>
            <div className='backdrop' onClick={this.toggleOpen}></div>
          </div>
        }
      </>
  }
}


class Navigation extends Component {
  componentDidMount() {
    ReactGA.pageview('/')
    this.props.history.listen(location => ReactGA.pageview(location.pathname))
  }
  state = {
    showMobileNav: false
  }

  toggleMobileNav = () => {
    this.setState({ showMobileNav: !this.state.showMobileNav })
  }

  render = () => {
    let { showMobileNav } = this.state
    let { username, access_token, premium } = this.props

    return <>
      <header className="navigation">
        <Link to={routes.HOME}>candidgirls.io</Link>
        {access_token
          ? <NavAuth username={username} access_token={access_token} premium={premium} />
          : <NavPublic />}
        <MdMenu className='menu_icon' onClick={this.toggleMobileNav} />
      </header>
      {access_token
        ? <MobileNavAuth toggle={this.toggleMobileNav} show={showMobileNav} username={username} access_token={access_token} premium={premium} />
        : <MobileNavPublic toggle={this.toggleMobileNav} show={showMobileNav} />}
    </>
  }
}


const NavPublic = () =>
  <nav>
    <NavLink to={routes.STORE}>Premium</NavLink>
    <a href="https://forum.candidgirls.io">Forum</a>
    <SignIn>Sign In</SignIn>
  </nav>

const NavAuth = ({ username, premium }) =>
  <nav>
    <NavLink to={routes.STORE}>Premium</NavLink>
    <NavLink to={routes.UPLOAD}>Upload</NavLink>
    <a href="https://forum.candidgirls.io">Forum</a>
    <UserMenu username={username} premium={premium} />
  </nav>

const MobileNavPublic = ({ show, toggle }) => show &&
  <div className='mobile_nav' onClick={toggle}>
    <NavLink to={routes.STORE}>Premium</NavLink>
    <a href="https://forum.candidgirls.io">Forum</a>
    <SignIn>Sign In</SignIn>
  </div>

const MobileNavAuth = ({ show, toggle, username, premium }) => show &&
  <div className='mobile_nav'>
    <NavLink to={routes.STORE} onClick={toggle}>Premium</NavLink>
    <NavLink to={routes.UPLOAD} onClick={toggle}>Upload</NavLink>
    <a href="https://forum.candidgirls.io">Forum</a>
    <UserMenu username={username} premium={premium} />
  </div>


const mapStateToProps = state => ({
  username: state.username,
  premium: state.premium,
  access_token: state.access_token
})

const mapDispatchToProps = dispatch => ({
  setLoginData: (access_token, username, premium) => dispatch(actions.setLoginData(access_token, username, premium))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation))